module.exports = __webpack_public_path__ + "media/bgm_game.60c42ba1.mp3";